import { user } from '../../api'

const state = {
  encCode: '',
  success: {
    name: '',
    birthDate: '',
    gender: '',
    mobileno: '',
    dupInfo: ''
  },
  url: '',
  isTemp: {
    isCertificated: false,
    name: '',
    birthDate: '',
    fail: false
  },
  isDub: {
    dupCheck: false
  }
}

const getters = {
  getEncCode: state => state.encCode,
  getSuccess: state => state.success,
  getUrl: state => state.url,
  getIsTemp: state => state.isTemp,
  getDup: state => state.isDub
}

const mutations = {
  SET_ENC_CODE (state, payload) {
    state.encCode = payload
  },
  SET_IDENTITY_SUCCESS (state, payload) {
    state.success = payload
  },
  SET_URL (state, payload) {
    state.url = payload
  },
  SET_IS_TEMP (state, payload) {
    state.isTemp = payload
  },
  SET_IS_DUP (state, payload) {
    state.isDub = payload
  }
}

const actions = {
  IDENTITY_SUCCESS_POST ({ commit }, payload) {
    return user.identitySuccessPost(payload)
      .then((data) => commit('SET_IDENTITY_SUCCESS', data.response))
  },
  IS_TEMP ({ commit }, payload) {
    return user.isTemp(payload)
      .then((data) => commit('SET_IS_TEMP', data.response))
  },
  IS_DUP ({ commit }, payload) {
    return user.isDup(payload)
      .then((data) => commit('SET_IS_DUP', data.response))
  }
}

export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
